/**
 * PauseOverlay Component
 * 
 * Semi-transparent overlay displayed when user manually pauses the session.
 * Shows "PAUSED" indicator, button to resume, and optional save button.
 */

import { useTranslation } from 'react-i18next';

interface PauseOverlayProps {
  onResume: () => void;
  onSave?: () => Promise<void>;
  isSaving?: boolean;
}

export default function PauseOverlay({ onResume, onSave, isSaving = false }: PauseOverlayProps) {
  const { t } = useTranslation();
  
  return (
    <div className="fixed inset-0 bg-gray-900/60 backdrop-blur-sm flex items-center justify-center z-20 pointer-events-auto">
      <div className="bg-gray-800/90 border-4 border-gray-600 rounded-3xl px-12 py-8 shadow-2xl transform scale-110">
        <div className="text-center">
          <div className="text-6xl mb-4">⏸️</div>
          <div className="text-4xl font-bold text-white mb-2">
            {t('scenario.session.paused')}
          </div>
          <button
            onClick={onResume}
            disabled={isSaving}
            className="mt-6 px-8 py-3 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 disabled:opacity-60 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all duration-200 transform hover:scale-105 text-lg"
          >
            {t('scenario.session.resume')} →
          </button>
          {onSave && (
            <button
              onClick={onSave}
              disabled={isSaving}
              className="mt-4 block w-full px-8 py-3 bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 disabled:from-green-800 disabled:to-green-900 disabled:opacity-60 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all duration-200 transform hover:scale-105 text-lg"
            >
              {isSaving
                ? t('scenario.session.saving', 'A guardar...')
                : t('scenario.session.saveAndExit', 'Guardar e Sair')}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

